import { observable } from 'mobx';
import { CONVENIENCE_STORE } from '../Config';

class ConvenienceStore {
  @observable storeType: CONVENIENCE_STORE;

  @observable storeName: string;

  @observable fullAddress: string;

  @observable postalCode: string;

  @observable phoneNumber: string;

  @observable isReady: boolean;
}

export default ConvenienceStore;
